var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSanofi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 30,
    viewBox: "0 0 141 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.51 5.19873H97.6387V24.7066H100.51V5.19873Z",
    fill: "#08576D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5942 7.67445C62.7322 7.67445 59.6624 10.9423 59.6624 15.0023C59.6624 19.0128 62.7817 22.1816 66.7427 22.1816C70.6542 22.1816 73.7735 19.0128 73.7735 15.0023C73.724 10.8432 70.6542 7.67445 66.5942 7.67445ZM66.6932 5.05029C72.2386 5.05029 76.5957 9.40738 76.5957 15.0023C76.5957 20.4487 72.1396 24.9048 66.6932 24.9048C61.1973 24.9048 56.7412 20.4487 56.7412 15.0023C56.7412 9.4569 61.1478 5.05029 66.6932 5.05029Z",
    fill: "#08576D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68417 7.42679C4.90173 7.42679 3.36684 8.6646 3.56489 10.4966C3.66392 11.2888 4.06002 11.7839 4.8027 12.279C5.00075 12.4275 5.44636 12.5761 5.991 12.7741C6.53564 12.9722 7.22881 13.2197 7.92198 13.4673C9.30833 13.9624 10.7442 14.5071 11.3383 15.1012C12.3781 16.0915 12.9722 17.3293 12.9722 18.8146C12.9722 22.4786 10.0015 24.9542 6.53564 24.9542C3.06977 25.0037 0.0990248 22.5776 0 19.0127H2.77269C3.11928 21.4388 4.65417 22.5281 6.58515 22.5281C8.3676 22.5281 10.2491 21.3893 10.2491 19.3098C10.2491 18.171 9.70443 17.3293 8.66467 16.7846C8.41711 16.6361 8.02101 16.4876 7.52589 16.339C7.08027 16.1905 6.53564 15.9924 5.991 15.8439C4.90173 15.4973 3.76294 15.1012 3.06977 14.6556C1.68342 13.8139 0.792198 12.378 0.792198 10.6946C0.742686 7.32777 3.26782 4.95117 6.7832 4.95117C9.55589 4.95117 12.4276 7.12972 12.6257 10.249H9.85297C9.70443 8.56558 8.26857 7.42679 6.68417 7.42679Z",
    fill: "#08576D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2799 5.19873H92.4892V7.82289H84.2207V14.1605H92.4892V16.7846H84.2207V24.7066H81.3985V7.12971C81.3489 6.04044 82.2402 5.19873 83.2799 5.19873Z",
    fill: "#08576D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8082 9.75397V24.7067H36.9365V7.03079C36.9365 5.94152 37.8277 5.05029 38.917 5.05029C39.6102 5.05029 40.2043 5.34737 40.6004 5.99103C43.4226 10.5462 48.6215 19.2108 49.1661 20.1516V5.19883H52.0378V22.8748C52.0378 23.964 51.1466 24.8553 50.0573 24.8553C49.3641 24.8553 48.77 24.5582 48.3739 23.9145C45.5517 19.3594 40.3529 10.6947 39.8082 9.75397Z",
    fill: "#08576D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1123 8.81319L21.2406 16.6857H26.984L24.1123 8.81319ZM20.2999 19.2108L18.3194 24.7067H15.3486L22.3299 6.23854C22.5774 5.54537 23.3201 5.00073 24.1123 5.00073C24.9045 5.00073 25.6472 5.49586 25.8948 6.23854L32.876 24.7067H29.9053L27.8753 19.2108H20.2999Z",
    fill: "#08576D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.675 10.4471C134.872 3.36684 129.426 9.60541 124.029 8.81321C118.632 8.07052 118.434 0.643661 125.068 0.0495124C125.217 0.0495124 125.366 0 125.564 0C132.149 0.0495124 137.744 4.45612 139.675 10.4471Z",
    fill: "#08576D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.774 10.8433C140.12 12.1306 140.318 13.5169 140.318 14.9528C140.318 23.2214 133.634 29.9055 125.365 29.9055C121.751 29.9055 118.434 28.6182 115.81 26.4397C116.849 26.8358 118.038 27.0338 119.077 27.0338C132.644 27.1328 126.851 9.11032 139.774 10.8433Z",
    fill: "#08576D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.919 25.2514C118.038 26.3902 115.067 26.0436 112.988 23.2214C112.542 22.5778 112.146 21.9341 111.849 21.34C110.958 19.409 110.413 17.2304 110.413 14.9529C110.413 14.3587 110.463 13.7646 110.512 13.1704C113.78 17.577 117.543 17.4285 119.919 18.8643C120.959 19.508 121.702 20.6963 121.702 22.0331C121.702 23.37 120.959 24.6078 119.919 25.2514Z",
    fill: "#08576D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanofi);
export default __webpack_public_path__ + "static/media/sanofi.55c8c6378ff63cc7fcaa12904037c10d.svg";
export { ForwardRef as ReactComponent };